import type { ISbStoryData } from '@storyblok/js';
import type { PageStoryblok } from '$types/bloks';
import type { DynamicPage } from '$pages/dynamic-page.svelte';

type PageStory = ISbStoryData<PageStoryblok>;

export type Page = {
  story: PageStory;
};

export const isPageStory = (story: DynamicPage['story']): story is PageStory => {
  return story.content.component === 'page';
};
export const isPage = (data: DynamicPage): data is Page => {
  return data.story.content.component === 'page';
};

export const PAGE_RELATIONS = [] as const;

export const getPageData = async ({ story }: { story: PageStory }): Promise<Page> => {
  return {
    story
  };
};
